"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.number.constructor");
var _vuex = require("vuex");
var _comChannel = _interopRequireDefault(require("../components/com-channel"));
var _comRegChannels = _interopRequireDefault(require("../components/com-reg-channels"));
var _comSchannel = _interopRequireDefault(require("../components/com-schannel"));
var _comPopStatus = _interopRequireDefault(require("./com-pop-status"));
var _comConfigItems = _interopRequireDefault(require("./com-config-items"));
var _comConfigItems2 = _interopRequireDefault(require("./com-config-items-2"));
var _fansConfig = _interopRequireDefault(require("./fans-config"));
var _goodsConfig = _interopRequireDefault(require("./goods-config"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import ComCenterChannels from '../components/com-center-channels';
//导粉
//商城
var _default2 = exports.default = {
  components: {
    ComChannel: _comChannel.default,
    ComSchannel: _comSchannel.default,
    // ComCenterChannels,
    ComRegChannels: _comRegChannels.default,
    ComPopStatus: _comPopStatus.default,
    ComConfigItems: _comConfigItems.default,
    ComConfigItems2: _comConfigItems2.default,
    FansConfig: _fansConfig.default,
    GoodsConfig: _goodsConfig.default,
    DefaultConfig: function DefaultConfig() {
      return {
        template: '<div></div>'
      };
    }
  },
  props: {
    title: {
      type: String
    },
    component_name: {
      // 组件的文件夹名（唯一）
      type: String
    },
    limit: {
      // 新增配置项的限制个数，默认不限制
      type: Number
    },
    initConfigNum: {
      // 配置项初始展示个数 (用于复制空白项使用)
      type: Number,
      default: function _default() {
        return 1;
      }
    },
    styleConfig: {
      // 配置样式 （详细参数见组件ComConfigItems）
      type: Object
    },
    configItemId: {
      // 配置组件选择，默认是1，即组件 ComConfigItems
      type: Number,
      default: function _default() {
        return 1;
      }
    },
    addBtnShow: {
      // 增加配置项个数按钮
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      type: this.$route.query.type,
      // 区分应用('')还是模板（public）
      dialogVisible: false,
      copySelect: '0',
      // 复制项选择,默认第一项
      showDelete: false,
      canRender: false
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapState)({
    cur_select_module: function cur_select_module(state) {
      return state.components.cur_select_module;
    },
    cur_select_module_index: function cur_select_module_index(state) {
      return state.components.cur_select_module_index;
    },
    active_content_key: function active_content_key(state) {
      return state.components.active_content_key;
    },
    active_content_index: function active_content_index(state) {
      return state.components.active_content_index;
    }
  })), {}, {
    moreConfigItem: function moreConfigItem() {
      var configData = this.cur_select_module[this.cur_select_module_index].component[this.active_content_key].config_data || [];
      var res = this.limit > configData.length;
      var flag = res && this.addBtnShow;
      return flag;
    },
    currentConfig: function currentConfig() {
      switch (this.configItemId) {
        case 1:
          return 'ComConfigItems';
        case 2:
          return 'ComConfigItems2';
        case 3:
          return 'FansConfig';
        case 4:
          return 'GoodsConfig';
        default:
          return 'DefaultConfig';
      }
    }
  }),
  mounted: function mounted() {
    this.initListData();
  },
  methods: {
    initListData: function () {
      var _initListData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var loading, cur_select_module, cur_select_module_index, channel_component_length, params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              cur_select_module = this.cur_select_module, cur_select_module_index = this.cur_select_module_index; // 组件渠道内容配置数
              channel_component_length = cur_select_module[cur_select_module_index].component.length;
              params = {
                page: 1,
                per_page: 500
              };
              this.$store.commit('components/SET_INIT_CONTENT_LENGTH', channel_component_length);
              _context.next = 7;
              return this.$store.dispatch('common/getRegChannels', {
                params: params
              });
            case 7:
              if (channel_component_length > 0) {
                cur_select_module.map(function (v, k) {
                  v.component.map(function (v1, k1) {
                    return v1.index = k1;
                  });
                });
                this.canRender = true;
              }
              loading.close();
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initListData() {
        return _initListData.apply(this, arguments);
      }
      return initListData;
    }(),
    // 打开状态摄制弹窗
    openPopStatus: function openPopStatus() {
      this.$refs.statusPop.dialogVisible = true;
    },
    // 多渠道配置tab切换
    handleTab: function handleTab(index, key) {
      this.$store.commit('components/SET_CONTENT_INDEX', {
        active_content_index: index,
        active_content_key: key
      });
    },
    // 新增多渠道配置项
    addChannelContentItem: function addChannelContentItem() {
      var copySelect = this.copySelect,
        initConfigNum = this.initConfigNum,
        component_name = this.component_name;
      if (!/^[1-9]\d*|0$/.test(copySelect)) {
        this.$message.error('请选择一项');
        return;
      }
      this.$store.commit('components/ADD_CUR_CONTENT', {
        copySelect: copySelect,
        initConfigNum: initConfigNum,
        component_name: component_name
      });
      this.dialogVisible = false;
    },
    // 删除多渠道配置项
    deleteChannelContentItem: function deleteChannelContentItem(key, index) {
      var _this = this;
      this.$confirm('即将删除该项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.$store.commit('components/REMOVE_CUR_CONTENT', {
          key: key,
          index: index
        });
        _this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(function () {});
    },
    // 显示删除操作
    deleteHandle: function deleteHandle() {
      var showDelete = this.showDelete;
      this.showDelete = !showDelete;
    },
    // 数据同步
    update: function update(data) {
      var cur_select_module = this.cur_select_module;
      this.$store.commit('components/UPDATE_CUR_SELECT_MOUDLE', cur_select_module);
    },
    // 新增内容配置项
    addConfigItem: function addConfigItem() {
      // 个数限制 (字段：config_data)
      var limit = this.limit,
        cur_select_module = this.cur_select_module,
        cur_select_module_index = this.cur_select_module_index,
        active_content_key = this.active_content_key;
      var configData = cur_select_module[cur_select_module_index].component[active_content_key].config_data || [];
      if (configData.length >= limit) {
        this.$message.error("\u5F53\u524D\u7EC4\u4EF6\u53EA\u80FD\u914D\u7F6E".concat(limit, "\u9879\u5185\u5BB9"));
        return;
      }
      this.$store.commit('components/ADD_COMPONENT_CONFIG_ITEM');
    },
    validator: function validator() {
      if (typeof this.$refs.configRef.validator === 'function') {
        return this.$refs.configRef.validator();
      }
      return Promise.resolve(true);
    }
  }
};